import { centerOfMass } from '@turf/turf'
import L from 'leaflet'
import { useMemo } from 'react'
import { renderToStaticMarkup } from 'react-dom/server'
import { Marker } from 'react-leaflet'

import { MarkerCluster } from '@/components/map/marker-cluster'
import { Region } from '@/services/get-region-by-id'

import { useStyles } from './styles'

interface FieldsNamesProps {
  geojson: NonNullable<Region['geojson']>
  fieldColumnName: string
}

export default function FieldsNames({
  geojson,
  fieldColumnName,
}: FieldsNamesProps) {
  const classes = useStyles()

  const fieldNameMarkers = useMemo(() => {
    return geojson.features
      .map((feature) => {
        const fieldId = feature.properties?.id
        if (!fieldId) return null

        const fieldName = feature.properties[fieldColumnName]

        const centerOfFeature = centerOfMass(feature)
        const position = {
          lat: centerOfFeature.geometry.coordinates[1],
          lng: centerOfFeature.geometry.coordinates[0],
        }

        return (
          <Marker
            key={fieldId}
            position={position}
            icon={L.divIcon({
              className: classes.marker,
              html: renderToStaticMarkup(<label>{String(fieldName)}</label>),
            })}
          />
        )
      })
      .filter(Boolean)
  }, [geojson])

  return (
    <MarkerCluster showCoverageOnHover={false}>
      {fieldNameMarkers}
    </MarkerCluster>
  )
}
